import { useAccountApi } from '@hooks/api/account/useAccountApi';
import { usePatchPutApi } from '@hooks/api/usePatchPutApi';

import type { ApiOptions, BaseResult } from '../../../types/api';
import type { CommunicationsRequest } from '../../../types/auth';

export const useUpdateCommunications = (
  options: ApiOptions<BaseResult, CommunicationsRequest> = {}
) => {
  const api = useAccountApi();

  const { update, ...response } = usePatchPutApi({
    ...options,
    getSuccessMessage: () => `Communications updated`,
    onSuccess: (data, ...args) => {
      options?.onSuccess?.(data, ...args);
    },
    request: (params) => api.updateCommunications(params),
  });

  return {
    ...response,
    updateCommunications: update,
  };
};
